import { createSelector } from 'reselect'
import { objectsToArray, sortArrayBy } from 'functions/utilities'

const getParams = (state, props) => ({ state, props })

const campaignImageSelector = createSelector(
  [getParams],
  (params) => {
    const { state, props } = params
    const { images } = state.entities
    const { campaign } = props

    const imageArray = objectsToArray(images)

    const filtered = imageArray.filter((image) => {
      const {
        hidden, imageable_type, imageable_id, private: isPrivate,
      } = image

      if (imageable_type === 'Campaign' && imageable_id === campaign.id && !hidden && !isPrivate){
        return true
      }

      return false
    })

    return sortArrayBy(filtered.map((image, index) => ({ ...image, index })), 'asc', 'sort')
  },
)

export default campaignImageSelector
